export default __webpack_public_path__ + "static/media/oob-trimmed-linux.6008ada2.avif";